export enum LocalEventType {
  EVENT_PRODUCT= 'product',
  EVENT_LINK = 'link',
  EVENT_PAGE = 'page',
}
